export default __webpack_public_path__ + "static/media/ibnsalman2.2b4a34b6.jpg";